module.exports = __webpack_public_path__ + "media/media/favicon/android-chrome-256x256-437d779f4f0d58241458b67b8d1afdad.png";